import { render, staticRenderFns } from "./baseinfo.vue?vue&type=template&id=46b59336&scoped=true"
import script from "./baseinfo.vue?vue&type=script&lang=js"
export * from "./baseinfo.vue?vue&type=script&lang=js"
import style0 from "./baseinfo.vue?vue&type=style&index=0&id=46b59336&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b59336",
  null
  
)

export default component.exports